import { useMemo } from 'react';
import { useActiveCapabilities } from '@rsos/reduxDataStore/src/features/capstone/psapInfo';
import { useGetPreconfiguredMessagesQuery } from '@rsos/reduxDataStore/src/features/preconfiguredMessages';
import {
  hasDisabledSmartPhrases,
  messageRequiresLocation,
} from './AllMessages/utils';

type Options = {
  hasRequestLocation?: boolean;
};

export function useEnabledPreconfiguredMessages(
  orgName: string | undefined,
  { hasRequestLocation = false }: Options = {},
) {
  const activeCapabilities = useActiveCapabilities();
  const { data: preconfiguredMessages = [] } = useGetPreconfiguredMessagesQuery(
    { org: orgName ?? '', enabled: true },
    { skip: !orgName },
  );

  return useMemo(
    () =>
      preconfiguredMessages.filter(message => {
        if (hasDisabledSmartPhrases(message, activeCapabilities)) {
          return false;
        }

        if (messageRequiresLocation(message)) {
          return hasRequestLocation;
        }

        return true;
      }),
    [activeCapabilities, hasRequestLocation, preconfiguredMessages],
  );
}
